export default "__VITE_ASSET__3KunuMwb__"